import { render, staticRenderFns } from "./vmMachineAbandoned.vue?vue&type=template&id=940a00dc&scoped=true&"
import script from "./vmMachineAbandoned.vue?vue&type=script&lang=js&"
export * from "./vmMachineAbandoned.vue?vue&type=script&lang=js&"
import style0 from "./vmMachineAbandoned.vue?vue&type=style&index=0&id=940a00dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "940a00dc",
  null
  
)

export default component.exports